export const partnersImages = [
  './assets/partners/partner-1.png',
  './assets/partners/partner-2.png',
  './assets/partners/partner-3.png',
  './assets/partners/partner-4.png',
];
